// coord-frontend/src/components/conversation/CoordMessageHeader.js
import React from "react";
import CoordAvatar from "./CoordAvatar";

// Speaker line above an AI answer, and above the loading dots so the answer
// replaces them in place (MessageList). The name is real text. h-6 + mb-2 =
// 32 px: compact, so a long answer isn't pushed down on a phone.
const CoordMessageHeader = () => (
  <div className="flex items-center gap-2 h-6 mb-2">
    <CoordAvatar />
    <span className="text-sm font-semibold text-text-primary">Coord</span>
  </div>
);

export default CoordMessageHeader;
